var render = function render(){var _vm=this,_c=_vm._self._c;return _c('date-picker',{staticClass:"ps-date-field",attrs:{"type":"date","format":"MM-DD-YYYY","value-type":"YYYY-MM-DD","value":_vm.value || null,"placeholder":_vm.placeholder,"disabled":_vm.disabled,"append-to-body":_vm.appendToBody,"editable":true,"clearable":false},on:{"input":_vm.onInput}})
}
var staticRenderFns = []

export { render, staticRenderFns }